$(document).ready(function() {
  $("body").on("change", ".file-input", function() {
    if ($(this)[0].files[0] !== undefined) {
      $(this)
        .parent().find(".label-wording")
        .html($(this)[0].files[0].name);
    }
  });
});
